import { render, staticRenderFns } from "./RoomPreview.vue?vue&type=template&id=37d6ff0d&"
import script from "./RoomPreview.vue?vue&type=script&lang=js&"
export * from "./RoomPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports